import { IRequestStatus } from "../../../store/@types/requests";

export const getRequestStatusValue = (
  status: IRequestStatus | null | undefined,
): string => {
  if (typeof status === "string") return status;
  return status?.name ?? "";
};
